import RuleProvider from 'diagram-js/lib/features/rules/RuleProvider';
import EventBus from 'diagram-js/lib/core/EventBus';

/**
 * Created By Elia Rohana on 3/20/19
 */
export class ElementAutoResizeRule extends RuleProvider {

    constructor(eventBus: EventBus) {
        super(eventBus);
    }

    init() {
        super.addRule('element.autoResize', 10001, (context) => {
            return false;

        });
    }
}
